import storeAction from "../typed-actions";
import router from "@/router";
import { Toast } from "vant";
// 登录成功 - 初始化信息
export function loginDone(res) {
  console.log("res", res);
  const userId = res.userinfo.user_id;
  const id = res.userinfo.id;
  const groupId = res.userinfo.group_id;
  const idcard = res.userinfo.idcard;
  storeAction.setToken(res.userinfo.token);
  storeAction.setCurrentUserId(userId);
  storeAction.setCurrentUser(res.userinfo);
  storeAction.setsessionStorage("userId", userId);
  storeAction.setsessionStorage("id", id);
  storeAction.setCurrentUserMoney(res.userinfo.money);
  storeAction.setsessionStorage("money", res.userinfo.money);

  // 关键：登录/注册后立刻把 group_id 写入 store + sessionStorage，
  // 否则像 Recharge/Withdraw 这种页面会认为你还是游客（group_id 为空或不是 1）
  storeAction.setCurrentUserGroup_id(groupId);
  storeAction.setsessionStorage("group_id", groupId);

  // 顺手同步一下身份证状态（Withdraw/Baseinfo 会用到）
  storeAction.setCurrentUserusercrud(idcard);
  storeAction.setsessionStorage("idcard", idcard);
  Toast.loading({
    message: "loading...",
    forbidClick: true,
    duration: 500,
    onClose() {
      router.push(`/`);
    },
  });
}
